module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("csepq"))).then(() => parcelRequire('mucvJ'));